import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';
import ApproveButton from './ApproveButton';
import CancelButton from './CancelButton';
import RejectButton from './RejectButton';
import RemarksTextArea from './RemarksTextArea';
import { isWebView } from '../../../utils';

const ActionButtons = ({
  handleApproveClick,
  handleRejectClick,
  closeDialog,
  remarksInput,
  handleRemarksChange,
  isApproveDisabled,
  isRejectDisabled,
  customApproveBtnText,
}: any) => {
  const isMobile = useAppSelector(selectIsMobileView);
  const [isRemarksFocused, setIsRemarksFocused] = useState(false);
  const [keyboardInsetHeight, setKeyboardInsetHeight] = useState(0);

  const isInWebView = isWebView();

  useEffect(() => {
    if (!isInWebView) return;

    const hasVisualViewport = typeof window !== 'undefined' && 'visualViewport' in window;
    if (!hasVisualViewport) return;

    const viewport = window.visualViewport;
    if (!viewport) return;

    const updateKeyboardHeight = () => {
      const keyboardHeight = window.innerHeight - viewport.height;
      setKeyboardInsetHeight(keyboardHeight > 0 ? keyboardHeight : 0);
    };

    viewport.addEventListener('resize', updateKeyboardHeight);
    viewport.addEventListener('scroll', updateKeyboardHeight);

    return () => {
      viewport.removeEventListener('resize', updateKeyboardHeight);
      viewport.removeEventListener('scroll', updateKeyboardHeight);
    };
  }, [isInWebView]);

  useEffect(() => {
    if (isInWebView && isRemarksFocused && keyboardInsetHeight > 0) {
      setTimeout(() => {
        window.scrollBy({
          top: -keyboardInsetHeight,
          behavior: 'smooth',
        });
      }, 100);
    }
  }, [isInWebView, isRemarksFocused, keyboardInsetHeight]);

  return (
    <div
      style={{
        width: '100%',
        minHeight: '60px',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        padding: isMobile ? '0' : '0 48px',
        boxSizing: 'border-box',
        ...(isMobile && {
          flexDirection: 'column',
        }),
        ...(isMobile &&
          isRemarksFocused &&
          keyboardInsetHeight > 0 && {
            marginBottom: `${keyboardInsetHeight}px`,
          }),
      }}
    >
      <RemarksTextArea
        value={remarksInput}
        onChange={handleRemarksChange}
        isDisabled={isApproveDisabled && isRejectDisabled}
        onFocus={() => setIsRemarksFocused(true)}
        onBlur={() => setIsRemarksFocused(false)}
      />
      <div
        style={{
          ...(isMobile && {
            width: '90%',
            display: 'flex',
            justifyContent: 'space-between',
            maxWidth: '500px',
          }),
        }}
      >
        <ApproveButton
          onClick={handleApproveClick}
          isDisabled={isApproveDisabled}
          btnText={customApproveBtnText}
        />
        <RejectButton onClick={handleRejectClick} isDisabled={isRejectDisabled} />
        <CancelButton onClick={closeDialog} />
      </div>
    </div>
  );
};

export default ActionButtons;
